// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"8585d71f","997":"3bb5ccf0"}[chunkId] + ".chunk.js";
};